import axios from "axios";
import { API_BASE_URL } from "../config/apiBase";

if (process.env.NODE_ENV === "development") {
  console.log("API Base URL:", API_BASE_URL || "(same-origin)");
}

const API = axios.create({
  baseURL: API_BASE_URL || undefined,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;
